import React, { Component } from 'react'

import style from './Grid.css'

export default class ContainerFluid extends Component {
  render() {
    return (
      <div
        {...this.props}
        className={style.ContainerFluid}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Grid/ContainerFluid.js